import React, { useEffect, useState } from "react";
import { Form, Input, Row, Col, Card, Table, Typography, Button, InputNumber, Popconfirm, Space, Select, Modal, DatePicker, AutoComplete } from "antd";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import useMessage from "antd/es/message/useMessage";
import { LetterService } from "../../../Services/Manage/LetterService";
import Title from "antd/es/skeleton/Title";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { UserService } from "../../../Services/Manage/UserService";
import { BankService } from "../../../Services/Manage/BankService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CreatePayment from "../../modals/CreatePayment";

const AddQuotationData = ({
    Eqslected,
    data,
    selectedDate,
    eqData
}) => {
    const { Text, Title } = Typography;
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(3);
    const [grandTotal, setGrandTotal] = useState(0);
    const [message, msgContc] = useMessage();
    const [letterHead, setLetterHead] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedTC, setSelectedTC] = useState([]);
    const [selectedTCOption, setSelectedTCOption] = useState([]);
    const [dgSign, setDGsign] = useState(null);
    const [dgSignOption, setDGsignOption] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [bankAc, setBankAc] = useState(null);
    const [bankAcOption, setBankAcOption] = useState([]);
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);

    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [quotationNo, setQuotationNo] = useState(null);

    const handlePreview = () => {
        if (selectedValue) {
            setIsModalOpen(true);
        }
    };

    console.log(data, selectedDate);

    const getAllLetterhead = async () => {
        try {
            const request = await LetterService.getAllHead();
            setLetterHead(
                request.data.map((item, index) => ({
                    label: item.tag,
                    value: item.id,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);

        }
    };

    const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];
    const handleSearch = (value) => {
        setOptions(
            value
                ? taxOptions
                    .filter((tax) => tax.toLowerCase().includes(value.toLowerCase()))
                    .map((tax) => ({ value: tax }))
                : []
        );
    };

    const getBankAcOption = async () => {
        try {
            const request = await BankService.getAllBank();
            setBankAcOption(
                request.data.map((item, index) => ({
                    label: item.tag,
                    value: item.id,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);

        }
    };

    const getAllTCData = async () => {
        try {
            const response = await LetterService.getAllTC();
            setSelectedTCOption(
                response.data.map((item, index) => ({
                    label: item.tag,
                    value: item.id,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);
        }
    };

    const getDigitalSign = async () => {
        try {
            const response = await QuotationService.getDigitalSign();
            setDGsignOption(
                response.data.map((item) => ({
                    label: (
                        <img
                            src={`${ENDPOINT.base}/${item.image_path}`}
                            alt={`Signature ${item.id}`}
                            style={{ width: "100px", height: "auto", objectFit: "contain" }}
                        />
                    ),
                    value: item.id,
                    title: `Signature ${item.id}`,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllLetterhead();
        getAllTCData();
        getBankAcOption();
        getDigitalSign();
        form.setFieldsValue({
            quotationNo: data,
        });
    }, [data, form]);

    const numberToWords = (num) => {
        const a = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const g = ["", "Thousand", "Million", "Billion"];

        if (num === 0) return "Zero";

        let str = "";
        let grp = 0;

        while (num > 0) {
            let chunk = num % 1000;
            if (chunk) {
                let chunkStr = "";
                if (chunk > 99) {
                    chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
                    chunk %= 100;
                }
                if (chunk > 19) {
                    chunkStr += b[Math.floor(chunk / 10)] + " ";
                    chunk %= 10;
                }
                if (chunk > 0) chunkStr += a[chunk] + " ";
                str = chunkStr + g[grp] + " " + str;
            }
            num = Math.floor(num / 1000);
            grp++;
        }
        return str.trim();
    };

    useEffect(() => {
        calculateGrandTotal();

    }, [dataSource]);

    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const handleChange = (key, field, value) => {
        const newData = dataSource.map((item) => {
            if (item.key === key) {
                const updatedItem = { ...item, [field]: value };
                const basePrice = updatedItem.qty * updatedItem.unitprice;
                const taxPercent = updatedItem.tax || 0;
                const total = basePrice + (basePrice * taxPercent) / 100;

                // Round to nearest integer
                updatedItem.totalprice = Math.round(total);

                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };


    const calculateGrandTotal = () => {
        const total = dataSource.reduce((sum, item) => sum + item.totalprice, 0);
        setGrandTotal(total);
    };

    const handleAddPayment = async () => {
        try {
            const request = form.getFieldsValue();
            console.log("handleAddPayment", request.quotationNo);

            // save quotationNo and open modal
            setQuotationNo(request.quotationNo);
            setPaymentModalOpen(true);
        } catch (error) {
            console.error("Error in handleAddPayment:", error);
        }
    };

    const columns = [
        {
            title: "SI No",
            dataIndex: "key",
            width: '7%',
            align: 'center',
            key: "key",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (text, record) => (
                <TextArea
                    allowClear
                    rows={2}
                    value={text}
                    onChange={(e) => handleChange(record.key, "description", e.target.value)}
                />
            ),
        },
        {
            title: "Qty",
            dataIndex: "qty",
            width: '12%',
            align: 'center',
            key: "qty",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "qty", value)}
                />
            ),
        },
        {
            title: "Unit Price",
            dataIndex: "unitprice",
            align: 'center',
            width: '12%',
            key: "unitprice",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "unitprice", value)}
                />
            ),
        },
        {
            title: "Tax (in %)",
            dataIndex: "tax",
            width: '12%',
            align: 'center',
            key: "tax",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "tax", value)}
                />
            ),
        },
        {
            title: "Total Price",
            dataIndex: "totalprice",
            align: 'center',
            key: "totalprice",
            render: (text) => <Text>{text}</Text>,
            width: '10%'
        },
        {
            title: "Action",
            key: "action",
            align: 'center',
            width: 120,
            render: (_, record) => (
                <>
                    <Button
                        disabled={!Eqslected}
                        icon={<PlusOutlined />}
                        type="dashed"
                        size="large"
                        style={{ marginRight: 8 }}
                        onClick={() => handleAdd(record.key)}
                    />
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                        <Button disabled={!Eqslected} icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </>
            ),
        },
    ];

    const handleNewAdd = () => {
        setDataSource([...dataSource,
        {
            key: count,
            description: "", qty: 1, unitprice: 0, totalprice: 0
        },]);
        setCount(count + 1);
    };


    const handleAdd = (key) => {
        const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 };
        const index = dataSource.findIndex((item) => item.key === key);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, newRow);
        setDataSource(newData);
        setCount(count + 1);
    };


    const handleSave = async () => {
        try {
            console.log("Saved Data:", dataSource);

            // if (!selectedValue) {
            //     return message.warning("Please Select T & C");
            // }
            // if (!dgSign) {
            //     return message.warning("Please Select Sign");
            // }
            if (!dataSource || dataSource.length <= 0) {
                return message.warning("Please Add contents");
            }

            const request = form.getFieldsValue();
            console.log("Request:", request);
            console.log(selectedDate);

            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                qu_no: request.quotationNo
            }));

            const user = await UserService.getOmeUser();
       const data_insert = {
    qu_no: request.quotationNo,
    eq_no: eqData?.eq_id,
    date: selectedDate,
    tax_id: request?.tax_id,
    tax_type: request?.tax_type,
    tc_id: selectedValue?.id || null,
    sign_id: dgSign?.id || null,
    added_by: user.uid,
    bank_id: bankAc?.value || null
};


            const send_both = {
                formattedData: formattedData,
                quotation_insert: data_insert

            };
            console.log("Formatted Data:", send_both);

            const requests = await QuotationService.createQuotation(send_both);
            console.log(requests);

            if (requests.status) {
                message.success(requests.message);
                await navigate("/quotation/edit", { state: { qu_no: requests?.data?.qu_no } });
            } else {
                message.error(requests.message);
            }

        } catch (error) {
            console.error(error);

        }
    };


    const handleClear = async () => {
        setDataSource([]);
    }

    return (
        <>
            {msgContc}
            <Form form={form} layout="vertical">
                <Row gutter={[16, 16]} style={{ width: "100%" }}>
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Quotation No"    
                            name="quotationNo"
                            initialValue={data}
                        >
                            <Input size="large" readOnly />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Tax type"
                            name="tax_type"
                            initialValue={data?.cus_gst}
                        >
                            <AutoComplete
                                allowClear
                                style={{ width: "100%" }}
                                options={options}
                                onSearch={handleSearch}
                                placeholder="Enter Tax type (e.g. GST, VAT)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Tax ID"
                            name="tax_id"
                            initialValue={data?.cus_gst}
                        >
                            <Input
                                allowClear
                                placeholder="Enter Tax ID (e.g. 09AAACH7409R1ZZ)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>


            <Card
                style={{ marginTop: '30px', borderBlockColor: 'black' }}>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                            height: "64px",
                        }}
                    >
                        

                        <Button
                            disabled={!Eqslected}
                            icon={<PlusOutlined />}
                            size="large"
                            type="primary"
                            onClick={handleNewAdd}
                        >
                            Add Row
                        </Button>
                    </div>

                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                        rowKey="key"
                        summary={() => {
                            let totalQty = 0;
                            let totalprice = 0;

                            dataSource.forEach(({ qty, totalprice: rowTotal }) => {
                                totalQty += qty;
                                totalprice += rowTotal;
                            });

                            return (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={2}>
                                        <Text strong>Total</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={2}>
                                        <Text strong>{totalQty}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4}>
                                        <Text strong>{totalprice}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={5}></Table.Summary.Cell>
                                </Table.Summary.Row>
                            );
                        }}
                    />

                    <Row style={{ marginTop: 16 }}>
                        <Col span={12}>
                            <Text italic>In Words: {numberToWords(grandTotal)}</Text>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <Text strong>Grand Total: {grandTotal}</Text>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: 16 }}>
                        <Col span={12}>
                            <Form layout="vertical">
                                <Form.Item label="Select Terms & Condition" style={{ width: "100%" }}>
                                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                        <Select
                                            placeholder="Select option"
                                            options={selectedTCOption}
                                            size="large"
                                            style={{ width: "55%" }}
                                            onChange={(value, option) => setSelectedValue(option)}
                                        />

                                        <Button type="link" onClick={handlePreview}>
                                            Preview
                                        </Button>
                                    </div>

                                    <Modal
                                        title="Preview of selected T&C"
                                        open={isModalOpen}
                                        footer={null}
                                        onCancel={() => setIsModalOpen(false)}
                                    >
                                        {selectedValue?.data ? (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    border: "1px solid #f0f0f0",
                                                    borderRadius: "8px",
                                                    background: "#fafafa",
                                                    minHeight: "100px",
                                                }}
                                                dangerouslySetInnerHTML={{ __html: selectedValue.data }}
                                            />
                                        ) : (
                                            <p>No data selected</p>
                                        )}
                                    </Modal>

                                </Form.Item>
                            </Form>
                        </Col>

                        <Col span={12}>
                            <Form layout="vertical">
                                <Form.Item
                                    label="Select Bank Account"
                                    name="bank_ac"
                                
                                >
                                    <Select
                                        placeholder="Select option"
                                        options={bankAcOption}

                                        size="large"
                                        style={{ width: "70%" }}
                                        onChange={(value, option) => setBankAc(option)}
                                    />
                                </Form.Item>
                            </Form>
                        </Col>

                        <Col span={12}>
                            <Form layout="vertical">
                                <Form.Item
                                    label="Second Digital signature"
                                    name="dgselect"
                                
                                >
                                    <Select
                                        allowClear
                                        placeholder="Select option"
                                        options={dgSignOption}
                                        size="large"
                                        style={{ width: "50%" }}
                                        optionRender={(option) => option.data.label}
                                        fieldNames={{ label: "title", value: "value" }}
                                        onChange={(value, option) => {
                                            setDGsign(option);
                                        }}
                                    />

                                </Form.Item>
                            </Form>
                        </Col>

                    </Row>

                    <Row justify="end" style={{ marginTop: 16 }}>
                        <Space>
                            <Button disabled={!Eqslected} size="large" type="primary" onClick={handleAddPayment}>
                                Add payment Amount
                            </Button>

                            <Button disabled={!Eqslected} size="large" type="primary" onClick={handleSave}>
                                Save
                            </Button>

                            <Popconfirm title="Sure to clear?" onConfirm={handleClear}>
                                <Button disabled={!Eqslected} danger size="large">
                                    Clear
                                </Button>
                            </Popconfirm>
                        </Space>
                    </Row>
                </div>


                <Modal
                    width={800}
                    title={
                        <Typography.Title level={4}>Add Payment for: {quotationNo}</Typography.Title>
                    }
                    open={paymentModalOpen}
                    onCancel={() => setPaymentModalOpen(false)}
                    footer={null}
                    destroyOnClose
                >
                    {/* pass quotationNo only */}
                    {quotationNo && <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />}
                </Modal>
            </Card>
        </>
    );
};

export default AddQuotationData;
